import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

class Encoding extends React.Component {
    render() {
        const { model } = this.props;
        const { bitratetype, bitrate } = model;

        let encoder = model.encodertype;
        if (encoder === 'mp3') encoder = 'MP3';
        if (encoder === 'aac') encoder = 'AAC';

        return (
            <Section title="Encoding">
                <List>
                    <Row>
                        <Label>Encoder</Label>
                        <Value>{encoder}</Value>
                    </Row>
                    <Row>
                        <Label>Bitrate type</Label>
                        <Value>{bitratetype}</Value>
                    </Row>
                    <Row>
                        <Label>Bitrate</Label>
                        <Value>{bitrate / 1000} kb/s</Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(Encoding);



// WEBPACK FOOTER //
// ./src/sections/Encoding.js